import { render, staticRenderFns } from "./AccountSetting.vue?vue&type=template&id=5b179121&scoped=true"
import script from "./AccountSetting.vue?vue&type=script&lang=js"
export * from "./AccountSetting.vue?vue&type=script&lang=js"
import style0 from "./AccountSetting.vue?vue&type=style&index=0&id=5b179121&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b179121",
  null
  
)

export default component.exports